// export const ipBe = 'http://localhost:8000';
export const ipBe = 'https://backupbe.juraganakun.com';

export const ipApi = ipBe + '/api';
